/**
 * @copyright Copyright 2015-2020 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/keys",
    "dojo/on",
    "mw-form/ListBox",
    "../mixins/property/MnemonicMixin",
    "../mixins/property/MnemonicKeyNavDirectionMixin",
    "../mixins/ColumnWidthMixin",
    "../mixins/property/TypeMixin",
    "../mixins/property/DescriptionOverrideMixin",
    "../mixins/property/CompactMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "../mixins/AcceptFocusMixin",
    "../mixins/ScrollbarMixin",
    "../widgets/_ValidationMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, lang, keys, on, ListBox, MnemonicMixin, MnemonicKeyNavDirectionMixin, ColumnWidthMixin, TypeMixin,
             DescriptionOverrideMixin, CompactMixin, ShortcutMixin, AcceptFocusMixin, ScrollbarMixin, _ValidationMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([ListBox, MnemonicMixin, MnemonicKeyNavDirectionMixin,
        ColumnWidthMixin, TypeMixin, DescriptionOverrideMixin, CompactMixin, ShortcutMixin, AcceptFocusMixin, ScrollbarMixin, _ValidationMixin]), {

        visualFamily: "default",
        width: 150,
        height: 66,
        mnemonicKeyNavDirection: "horizontal",
        _scaleToParentWidth: true,

        _setItemsAttr: function (itemObjectList) {
            // Overriding the mw-form/ListBox _setItemsAttr so as to avoid resetting the value to null. 
            // see geck g2179487
            this._validateItemsArray(itemObjectList);
            var listToUpdateView = this._getItemsListAndInitInternalDs(itemObjectList);
            this._updateDom(listToUpdateView);

            this._set("items", itemObjectList);
            this._updateTooltipForClippedItems();

            if(this._started) {
                this._handleSelection(itemObjectList);
            }
        },

        //Preselection: if you pass in selected: true along with label and value.
        //Last selected:true wins if there are multiple selected:true in the case of selection mode being single

        _handleSelection: function (itemObjectList) {
            var selectedValues = [];

            itemObjectList.forEach(function (item) {
                if (item.selected === true) {
                    selectedValues.push(item.value);
                }
            }, this);
            //If no selected true is passed with items then ignore
            if (selectedValues.length > 0) {
                if (this.get("selectionMode") === "single") {
                    this.set("value", [selectedValues[selectedValues.length - 1] ]);
                } else {
                    this.set("value", selectedValues);
                }
            }

        },

        postCreate: function(e) {
            this.inherited(arguments);
            this.own(
                on(this.containerNode, "keydown", lang.hitch(this, "_handleKeyDownEvent"))
            );
        },

        startup: function() {
            this.inherited(arguments);
            this._handleSelection(this.get("items"));
        },

        _handleKeyDownEvent: function(event) {
            this.inherited(arguments);
            if((event.keyCode === keys.ESCAPE)) {
                this.emit("restorefocustolastnonrefuseelement");
            } else if((event.keyCode === keys.ENTER)) {
                this.emit("restorefocustolastnonrefuseelement");
                this.emit("commit", {});
            }
        }
    });
});
